import { handleRequest } from '../../axios';
import { axiosInstance } from './JsdhNotifikaceService';
import {
    HydroStanice,
    MeteoConfigDto,
    MeteoConfigResponse,
    MeteoHydroConfigDto,
    MeteoStatusDto,
    OrpEntry,
} from '../generated/models/Meteo';
import {
    METEO_CISELNIK_HYDRO_URL,
    METEO_CISELNIK_ORP_URL,
    METEO_CONFIG_URL,
    METEO_HYDRO_CONFIG_URL,
    METEO_STATUS_URL,
} from '../url';

const getOrpCiselnik = () =>
    handleRequest<OrpEntry[]>(() => axiosInstance.get(METEO_CISELNIK_ORP_URL));

const getConfig = () =>
    handleRequest<MeteoConfigResponse>(() => axiosInstance.get(METEO_CONFIG_URL));

const updateConfig = (dto: MeteoConfigDto) =>
    handleRequest<MeteoConfigResponse>(() => axiosInstance.put(METEO_CONFIG_URL, dto));

const getStatus = () =>
    handleRequest<MeteoStatusDto>(() => axiosInstance.get(METEO_STATUS_URL));

// HO-94 E4 hydro
const getHydroCiselnik = () =>
    handleRequest<HydroStanice[]>(() => axiosInstance.get(METEO_CISELNIK_HYDRO_URL));

const getHydroConfig = () =>
    handleRequest<MeteoHydroConfigDto>(() => axiosInstance.get(METEO_HYDRO_CONFIG_URL));

const updateHydroConfig = (dto: MeteoHydroConfigDto) =>
    handleRequest<MeteoHydroConfigDto>(() => axiosInstance.put(METEO_HYDRO_CONFIG_URL, dto));

const MeteoService = {
    getOrpCiselnik, getConfig, updateConfig, getStatus,
    getHydroCiselnik, getHydroConfig, updateHydroConfig,
};
export default MeteoService;
